// extracted by mini-css-extract-plugin
export default {"followus":"FollowUs_followus__8y9M9","href":"FollowUs_href__GSeN9"};